var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"infoMaTion"},[_c('editMyInfomation',{attrs:{"resumeInfo":_vm.resumeInfo},on:{"refreshData":_vm.refreshData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }